import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddOrganizationComponent } from './organization/components/add-organization/add-organization.component';
import { OrganizationComponent } from './organization/organization.component';

const routes: Routes = [
  { path: 'organization', component: OrganizationComponent },
  { path: 'add-customer', component: AddOrganizationComponent },
  { path: 'add-customer/:id', component: AddOrganizationComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountSetupRoutingModule { }



